/* tslint:disable */
/* eslint-disable */
/**
 * People Rock Platform API
 * REST API for the People Rock Platform - An AI-powered competency development platform.  ## Features - User authentication and authorization (JWT) - Role-based access control (ADMIN, TRAINER, PARTICIPANT) - User management - Internationalization support (Portuguese, English) - Locale management  ## Authentication Most endpoints require JWT authentication. To authenticate: 1. Register a new account: POST /auth/register 2. Or login with existing credentials: POST /auth/login 3. Copy the JWT token from the response 4. Click \"Authorize\" button above and enter: Bearer {token} 5. All subsequent requests will include the authorization header  ## Localization The API supports Portuguese (default) and English. Set the Accept-Language header: - `Accept-Language: pt` for Portuguese - `Accept-Language: en` for English  ## Rate Limiting - `POST /api/auth/login`: 10 requests per minute per IP - `POST /api/auth/register`: 5 requests per hour per IP - Other endpoints are not rate limited by the API  ## Support For API support, contact the development team via the contact information below. 
 *
 * The version of the OpenAPI document: 1.0.0-SNAPSHOT
 * Contact: dev@peoplerock.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AnswerResponse } from '../models';
// @ts-ignore
import type { AssignmentProgressResponse } from '../models';
// @ts-ignore
import type { PageAssignmentProgressResponse } from '../models';
// @ts-ignore
import type { Pageable } from '../models';
// @ts-ignore
import type { UpdateProgressRequest } from '../models';
/**
 * AssignmentProgressApi - axios parameter creator
 * @export
 */
export const AssignmentProgressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Mark assignment as completed
         * @param {number} progressId 
         * @param {string} [trainerNotes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAssignment: async (progressId: number, trainerNotes?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'progressId' is not null or undefined
            assertParamExists('completeAssignment', 'progressId', progressId)
            const localVarPath = `/api/progress/{progressId}/complete`
                .replace(`{${"progressId"}}`, encodeURIComponent(String(progressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (trainerNotes !== undefined) {
                localVarQueryParameter['trainerNotes'] = trainerNotes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get progress for plan and participant
         * @param {number} planId 
         * @param {number} participantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByPlanAndParticipant: async (planId: number, participantId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('findByPlanAndParticipant', 'planId', planId)
            // verify required parameter 'participantId' is not null or undefined
            assertParamExists('findByPlanAndParticipant', 'participantId', participantId)
            const localVarPath = `/api/progress/plan/{planId}/participant/{participantId}`
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)))
                .replace(`{${"participantId"}}`, encodeURIComponent(String(participantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get assignments pending review for trainer
         * @param {Pageable} pageable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPendingReviews: async (pageable: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageable' is not null or undefined
            assertParamExists('findPendingReviews', 'pageable', pageable)
            const localVarPath = `/api/progress/pending-reviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageable !== undefined) {
                for (const [key, value] of Object.entries(pageable)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the participant\'s submitted questionnaire answers for a plan assignment under review
         * @param {number} progressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionnaireResponses: async (progressId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'progressId' is not null or undefined
            assertParamExists('getQuestionnaireResponses', 'progressId', progressId)
            const localVarPath = `/api/progress/{progressId}/questionnaire-responses`
                .replace(`{${"progressId"}}`, encodeURIComponent(String(progressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request revision on assignment
         * @param {number} progressId 
         * @param {string} [trainerNotes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestRevision: async (progressId: number, trainerNotes?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'progressId' is not null or undefined
            assertParamExists('requestRevision', 'progressId', progressId)
            const localVarPath = `/api/progress/{progressId}/request-revision`
                .replace(`{${"progressId"}}`, encodeURIComponent(String(progressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (trainerNotes !== undefined) {
                localVarQueryParameter['trainerNotes'] = trainerNotes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start working on assignment
         * @param {number} progressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAssignment: async (progressId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'progressId' is not null or undefined
            assertParamExists('startAssignment', 'progressId', progressId)
            const localVarPath = `/api/progress/{progressId}/start`
                .replace(`{${"progressId"}}`, encodeURIComponent(String(progressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit assignment for review
         * @param {number} progressId 
         * @param {string} [feedback] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitAssignment: async (progressId: number, feedback?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'progressId' is not null or undefined
            assertParamExists('submitAssignment', 'progressId', progressId)
            const localVarPath = `/api/progress/{progressId}/submit`
                .replace(`{${"progressId"}}`, encodeURIComponent(String(progressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (feedback !== undefined) {
                localVarQueryParameter['feedback'] = feedback;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update progress feedback/notes
         * @param {number} progressId 
         * @param {UpdateProgressRequest} updateProgressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProgress: async (progressId: number, updateProgressRequest: UpdateProgressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'progressId' is not null or undefined
            assertParamExists('updateProgress', 'progressId', progressId)
            // verify required parameter 'updateProgressRequest' is not null or undefined
            assertParamExists('updateProgress', 'updateProgressRequest', updateProgressRequest)
            const localVarPath = `/api/progress/{progressId}`
                .replace(`{${"progressId"}}`, encodeURIComponent(String(progressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProgressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssignmentProgressApi - functional programming interface
 * @export
 */
export const AssignmentProgressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssignmentProgressApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Mark assignment as completed
         * @param {number} progressId 
         * @param {string} [trainerNotes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeAssignment(progressId: number, trainerNotes?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeAssignment(progressId, trainerNotes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentProgressApi.completeAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get progress for plan and participant
         * @param {number} planId 
         * @param {number} participantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByPlanAndParticipant(planId: number, participantId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssignmentProgressResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByPlanAndParticipant(planId, participantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentProgressApi.findByPlanAndParticipant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get assignments pending review for trainer
         * @param {Pageable} pageable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findPendingReviews(pageable: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageAssignmentProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findPendingReviews(pageable, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentProgressApi.findPendingReviews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the participant\'s submitted questionnaire answers for a plan assignment under review
         * @param {number} progressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionnaireResponses(progressId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnswerResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionnaireResponses(progressId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentProgressApi.getQuestionnaireResponses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Request revision on assignment
         * @param {number} progressId 
         * @param {string} [trainerNotes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestRevision(progressId: number, trainerNotes?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestRevision(progressId, trainerNotes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentProgressApi.requestRevision']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start working on assignment
         * @param {number} progressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startAssignment(progressId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startAssignment(progressId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentProgressApi.startAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Submit assignment for review
         * @param {number} progressId 
         * @param {string} [feedback] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitAssignment(progressId: number, feedback?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitAssignment(progressId, feedback, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentProgressApi.submitAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update progress feedback/notes
         * @param {number} progressId 
         * @param {UpdateProgressRequest} updateProgressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProgress(progressId: number, updateProgressRequest: UpdateProgressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProgress(progressId, updateProgressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentProgressApi.updateProgress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssignmentProgressApi - factory interface
 * @export
 */
export const AssignmentProgressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssignmentProgressApiFp(configuration)
    return {
        /**
         * 
         * @summary Mark assignment as completed
         * @param {AssignmentProgressApiCompleteAssignmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAssignment(requestParameters: AssignmentProgressApiCompleteAssignmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentProgressResponse> {
            return localVarFp.completeAssignment(requestParameters.progressId, requestParameters.trainerNotes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get progress for plan and participant
         * @param {AssignmentProgressApiFindByPlanAndParticipantRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByPlanAndParticipant(requestParameters: AssignmentProgressApiFindByPlanAndParticipantRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AssignmentProgressResponse>> {
            return localVarFp.findByPlanAndParticipant(requestParameters.planId, requestParameters.participantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get assignments pending review for trainer
         * @param {AssignmentProgressApiFindPendingReviewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPendingReviews(requestParameters: AssignmentProgressApiFindPendingReviewsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageAssignmentProgressResponse> {
            return localVarFp.findPendingReviews(requestParameters.pageable, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the participant\'s submitted questionnaire answers for a plan assignment under review
         * @param {AssignmentProgressApiGetQuestionnaireResponsesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionnaireResponses(requestParameters: AssignmentProgressApiGetQuestionnaireResponsesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AnswerResponse>> {
            return localVarFp.getQuestionnaireResponses(requestParameters.progressId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request revision on assignment
         * @param {AssignmentProgressApiRequestRevisionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestRevision(requestParameters: AssignmentProgressApiRequestRevisionRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentProgressResponse> {
            return localVarFp.requestRevision(requestParameters.progressId, requestParameters.trainerNotes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start working on assignment
         * @param {AssignmentProgressApiStartAssignmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAssignment(requestParameters: AssignmentProgressApiStartAssignmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentProgressResponse> {
            return localVarFp.startAssignment(requestParameters.progressId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit assignment for review
         * @param {AssignmentProgressApiSubmitAssignmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitAssignment(requestParameters: AssignmentProgressApiSubmitAssignmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentProgressResponse> {
            return localVarFp.submitAssignment(requestParameters.progressId, requestParameters.feedback, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update progress feedback/notes
         * @param {AssignmentProgressApiUpdateProgressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProgress(requestParameters: AssignmentProgressApiUpdateProgressRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentProgressResponse> {
            return localVarFp.updateProgress(requestParameters.progressId, requestParameters.updateProgressRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for completeAssignment operation in AssignmentProgressApi.
 * @export
 * @interface AssignmentProgressApiCompleteAssignmentRequest
 */
export interface AssignmentProgressApiCompleteAssignmentRequest {
    /**
     * 
     * @type {number}
     * @memberof AssignmentProgressApiCompleteAssignment
     */
    readonly progressId: number

    /**
     * 
     * @type {string}
     * @memberof AssignmentProgressApiCompleteAssignment
     */
    readonly trainerNotes?: string
}

/**
 * Request parameters for findByPlanAndParticipant operation in AssignmentProgressApi.
 * @export
 * @interface AssignmentProgressApiFindByPlanAndParticipantRequest
 */
export interface AssignmentProgressApiFindByPlanAndParticipantRequest {
    /**
     * 
     * @type {number}
     * @memberof AssignmentProgressApiFindByPlanAndParticipant
     */
    readonly planId: number

    /**
     * 
     * @type {number}
     * @memberof AssignmentProgressApiFindByPlanAndParticipant
     */
    readonly participantId: number
}

/**
 * Request parameters for findPendingReviews operation in AssignmentProgressApi.
 * @export
 * @interface AssignmentProgressApiFindPendingReviewsRequest
 */
export interface AssignmentProgressApiFindPendingReviewsRequest {
    /**
     * 
     * @type {Pageable}
     * @memberof AssignmentProgressApiFindPendingReviews
     */
    readonly pageable: Pageable
}

/**
 * Request parameters for getQuestionnaireResponses operation in AssignmentProgressApi.
 * @export
 * @interface AssignmentProgressApiGetQuestionnaireResponsesRequest
 */
export interface AssignmentProgressApiGetQuestionnaireResponsesRequest {
    /**
     * 
     * @type {number}
     * @memberof AssignmentProgressApiGetQuestionnaireResponses
     */
    readonly progressId: number
}

/**
 * Request parameters for requestRevision operation in AssignmentProgressApi.
 * @export
 * @interface AssignmentProgressApiRequestRevisionRequest
 */
export interface AssignmentProgressApiRequestRevisionRequest {
    /**
     * 
     * @type {number}
     * @memberof AssignmentProgressApiRequestRevision
     */
    readonly progressId: number

    /**
     * 
     * @type {string}
     * @memberof AssignmentProgressApiRequestRevision
     */
    readonly trainerNotes?: string
}

/**
 * Request parameters for startAssignment operation in AssignmentProgressApi.
 * @export
 * @interface AssignmentProgressApiStartAssignmentRequest
 */
export interface AssignmentProgressApiStartAssignmentRequest {
    /**
     * 
     * @type {number}
     * @memberof AssignmentProgressApiStartAssignment
     */
    readonly progressId: number
}

/**
 * Request parameters for submitAssignment operation in AssignmentProgressApi.
 * @export
 * @interface AssignmentProgressApiSubmitAssignmentRequest
 */
export interface AssignmentProgressApiSubmitAssignmentRequest {
    /**
     * 
     * @type {number}
     * @memberof AssignmentProgressApiSubmitAssignment
     */
    readonly progressId: number

    /**
     * 
     * @type {string}
     * @memberof AssignmentProgressApiSubmitAssignment
     */
    readonly feedback?: string
}

/**
 * Request parameters for updateProgress operation in AssignmentProgressApi.
 * @export
 * @interface AssignmentProgressApiUpdateProgressRequest
 */
export interface AssignmentProgressApiUpdateProgressRequest {
    /**
     * 
     * @type {number}
     * @memberof AssignmentProgressApiUpdateProgress
     */
    readonly progressId: number

    /**
     * 
     * @type {UpdateProgressRequest}
     * @memberof AssignmentProgressApiUpdateProgress
     */
    readonly updateProgressRequest: UpdateProgressRequest
}

/**
 * AssignmentProgressApi - object-oriented interface
 * @export
 * @class AssignmentProgressApi
 * @extends {BaseAPI}
 */
export class AssignmentProgressApi extends BaseAPI {
    /**
     * 
     * @summary Mark assignment as completed
     * @param {AssignmentProgressApiCompleteAssignmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentProgressApi
     */
    public completeAssignment(requestParameters: AssignmentProgressApiCompleteAssignmentRequest, options?: RawAxiosRequestConfig) {
        return AssignmentProgressApiFp(this.configuration).completeAssignment(requestParameters.progressId, requestParameters.trainerNotes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get progress for plan and participant
     * @param {AssignmentProgressApiFindByPlanAndParticipantRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentProgressApi
     */
    public findByPlanAndParticipant(requestParameters: AssignmentProgressApiFindByPlanAndParticipantRequest, options?: RawAxiosRequestConfig) {
        return AssignmentProgressApiFp(this.configuration).findByPlanAndParticipant(requestParameters.planId, requestParameters.participantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get assignments pending review for trainer
     * @param {AssignmentProgressApiFindPendingReviewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentProgressApi
     */
    public findPendingReviews(requestParameters: AssignmentProgressApiFindPendingReviewsRequest, options?: RawAxiosRequestConfig) {
        return AssignmentProgressApiFp(this.configuration).findPendingReviews(requestParameters.pageable, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the participant\'s submitted questionnaire answers for a plan assignment under review
     * @param {AssignmentProgressApiGetQuestionnaireResponsesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentProgressApi
     */
    public getQuestionnaireResponses(requestParameters: AssignmentProgressApiGetQuestionnaireResponsesRequest, options?: RawAxiosRequestConfig) {
        return AssignmentProgressApiFp(this.configuration).getQuestionnaireResponses(requestParameters.progressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request revision on assignment
     * @param {AssignmentProgressApiRequestRevisionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentProgressApi
     */
    public requestRevision(requestParameters: AssignmentProgressApiRequestRevisionRequest, options?: RawAxiosRequestConfig) {
        return AssignmentProgressApiFp(this.configuration).requestRevision(requestParameters.progressId, requestParameters.trainerNotes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start working on assignment
     * @param {AssignmentProgressApiStartAssignmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentProgressApi
     */
    public startAssignment(requestParameters: AssignmentProgressApiStartAssignmentRequest, options?: RawAxiosRequestConfig) {
        return AssignmentProgressApiFp(this.configuration).startAssignment(requestParameters.progressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit assignment for review
     * @param {AssignmentProgressApiSubmitAssignmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentProgressApi
     */
    public submitAssignment(requestParameters: AssignmentProgressApiSubmitAssignmentRequest, options?: RawAxiosRequestConfig) {
        return AssignmentProgressApiFp(this.configuration).submitAssignment(requestParameters.progressId, requestParameters.feedback, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update progress feedback/notes
     * @param {AssignmentProgressApiUpdateProgressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentProgressApi
     */
    public updateProgress(requestParameters: AssignmentProgressApiUpdateProgressRequest, options?: RawAxiosRequestConfig) {
        return AssignmentProgressApiFp(this.configuration).updateProgress(requestParameters.progressId, requestParameters.updateProgressRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

